// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"04fb63bb","78":"763003b2"}[chunkId] + ".chunk.js";
};